import styled, { css } from "styled-components";
import { theme } from "ui/themes";

interface ContainerButtonProps {
  borderLine?: boolean;
  fontSize?: string;
  scaleMedia?: number;
  isBlackTheme?: boolean;
}

interface DescriptionButtonProps {
  textVisibleMobile?: boolean;
}

export const DescriptionButton = styled.span<DescriptionButtonProps>`
  color: ${theme.colors.primary["200"]};
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: 1.2rem;
  @media ${theme.device.desktopFirst.mobileXL} {
    display: ${({ textVisibleMobile }) =>
      textVisibleMobile ? "none" : "inline"};
  }
`;

export const ContainerButton = styled.button<ContainerButtonProps>`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  font-size: ${({ fontSize }) => fontSize ?? "1.5rem"};

  border: ${({ borderLine }) => (borderLine ? "1px solid" : "none")};
  border-color: ${theme.colors.primary["200"]};
  border-radius: 4px;

  background: none;
  transition: background-color 300ms;

  :hover {
    background-color: ${theme.colors.primary["10"]};
  }

  @media ${theme.device.desktopFirst.laptop} {
    transform: scale(${({ scaleMedia }) => scaleMedia ?? 1});
    padding: 1.2rem 3rem;
  }

  @media ${theme.device.desktopFirst.tabletS} {
    padding: 1rem;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    border-radius: 4px;
    padding: 1rem 1.8rem;
  }

  ${({ isBlackTheme }) =>
    isBlackTheme &&
    css`
      border-color: ${theme.colors.blackFriday.white} !important;
      ${DescriptionButton} {
        color: ${theme.colors.blackFriday.white} !important;
      }

      &:hover {
        background-color: ${theme.colors.primary["200"]};
      }
    `}
`;
